import { error, finish } from '../../../modules/related-contingency/actions/add-markets';
import { request as getMarketsForRcTags } from '../../../modules/related-contingency/actions/get-markets-for-rc-tag';

import api from '../../../api';

export function request(dispatch, { data, tagId, query, getAll }) {
    api.put(`/contingencies/tag-content/${tagId}`, data)
        .then(res => {
            dispatch(finish(res));
            if (getAll) {
                dispatch(getMarketsForRcTags(tagId, query));
            }
        }).catch(err => {
            dispatch(error(res));
        });
}
